<template>
  <div class="examine">
    <el-table :data="examineList" class="mt18" empty-text="暂无审核">
      <el-table-column prop="sys" label="系统"></el-table-column>
      <el-table-column prop="market" label="市场"></el-table-column>
      <el-table-column prop="ver" label="版本"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props:{
    examineList:Array,
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/table.scss";
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background: #f7f2ff;
}
#app .el-table {
  /deep/.el-table--border th:first-child .cell,
  /deep/.el-table--border td:first-child .cell,
  /deep/ .cell {
    padding-left: 10px;
    text-overflow: unset;
  }
}
.select{
  margin-right: 16px;
}
p {
  margin-top: 5px;
  font-size: 14px;
  .tips {
    color: #fe7a42;
  }
}
.add-btn {
  width: 94px;
  height: 40px;
  margin-top: 24px;
}
.form {
  padding-left: 12px;
}
.submitbtn {
  width: 139px;
  height: 36px;
}
/deep/ .zt-input {
  width: 184px;
}
/deep/ .el-input--suffix{
  width: 184px;
}
</style>